import axios from "axios";
import config from "../config";
import { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

type PublicPlanRow = {
  is_trial_plan?: boolean;
  is_active?: boolean;
};

/**
 * Trial presente no catálogo público?
 * Por quê: register só mostra copy de teste se o plano Trial estiver publicado.
 * Ausente do catálogo = inexistente para o usuário (sem mensagem de “desativado”).
 * null = falha/rede — UI usa skeleton até resolver.
 */
export async function fetchPublicTrialActive(
  currency: "BRL" | "USD" = "BRL"
): Promise<boolean | null> {
  try {
    const { data } = await axios.get<ApiSuccess<PublicPlanRow[]>>(
      `${apiBase}/public/plans`,
      { params: { currency } }
    );
    if (!data?.success || !Array.isArray(data.data)) {
      return null;
    }
    // Catálogo omite trial inativo — some() false = inexistente na UI pública.
    return data.data.some(
      (p) => p && p.is_trial_plan === true && p.is_active !== false
    );
  } catch {
    return null;
  }
}
